import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Marta S.',
    location: 'Buenos Aires',
    age: '52 años',
    text: 'Pensé que la cirugía era mi única opción. El dolor nocturno desapareció en la primera semana usando el protocolo. Puedo volver a usar mis zapatos favoritos.',
    rating: 5,
    image: 'https://cdn.magicpatterns.com/uploads/wu1BiFY1eLFNNjgaoiEuh7/1694434769-asd1_(1).webp',
    imageAlt: 'Resultado real de Marta S. — reducción visible del juanete',
    imageCaption: 'Resultado a las 3 semanas'
  }, {
    name: 'Claudia R.',
    location: 'Córdoba',
    age: '48 años',
    text: 'Lo que más me sirvió fue el ebook. Entendí que mi alimentación estaba inflamando mis articulaciones. El kit físico es de excelente calidad, nada que ver con lo que venden en farmacias.',
    rating: 5,
    image: 'https://cdn.magicpatterns.com/uploads/pwUng31B3q2ijeWSZ8cjyp/1694434356-70124231-1691704145.2771_(1).webp',
    imageAlt: 'Antes y después de Claudia R. — corrección del Hallux Valgus',
    imageCaption: 'Antes y después — 30 días'
  }, {
    name: 'Patricia M.',
    location: 'Rosario',
    age: '61 años',
    text: "Llevo 3 semanas usándolo y mi dedo está visiblemente más derecho. Ya no siento ese 'fuego' al sacarme los zapatos. Una inversión en salud.",
    rating: 5,
    image: 'https://cdn.magicpatterns.com/uploads/kMHeDoa9P8shFistmkBmS3/1694434337-70124432-1691704148.6712_(1).webp',
    imageAlt: 'Antes y después de Patricia M. — reducción del juanete',
    imageCaption: 'Antes y después — 3 semanas'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-225">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-226">
        <div className="text-center mb-16" data-id="element-227">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4 font-serif" data-id="element-228">
            Historias de mujeres reales
          </h2>
          <p className="text-xl text-gray-600" data-id="element-229">
            Ellas ya recuperaron su libertad de caminar sin dolor.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-230">
          {testimonials.map((testimonial, index) => <Card key={index} className="border-none shadow-md overflow-hidden" data-id="element-231">
              {/* Result image */}
              <div className="relative bg-gray-100" data-id="element-232">
                <img src={testimonial.image} alt={testimonial.imageAlt} className="w-full h-52 object-contain" data-id="element-233" />
                <div className="absolute bottom-2 right-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full" data-id="element-234">
                  {testimonial.imageCaption}
                </div>
              </div>

              <CardContent className="p-6" data-id="element-235">
                <div className="flex mb-3" data-id="element-236">
                  {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="h-4 w-4 text-yellow-400 fill-yellow-400" data-id="element-237" />)}
                </div>
                <p className="text-gray-700 mb-5 italic text-sm leading-relaxed" data-id="element-238">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center border-t pt-4" data-id="element-239">
                  <div className="h-9 w-9 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-base flex-shrink-0" data-id="element-240">
                    {testimonial.name[0]}
                  </div>
                  <div className="ml-3" data-id="element-241">
                    <p className="text-sm font-semibold text-gray-900" data-id="element-242">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-243">
                      {testimonial.location}, {testimonial.age}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}